/**
 * Created by mqamhieh on 2/3/18.
 */
(function () {

    "use strict";

    angular
        .module("formsManager")
        .service("hFormsService", hFormsService);

    hFormsService.$inject = ['$injector'];

    function hFormsService ($injector) {
        var self = this;

        var forms = {};

        self.registerForm = function (formName, formObj) {
            forms[formName] = formObj;

            for (var i in formObj.dependencies) {
                formObj.dependencies[formObj.dependencies[i]] = $injector.get(formObj.dependencies[i]);
            }
        };

        self.getForm = function (formName) {
            return function (scope, name) {
                var form = this;

                var functionArgs = [];

                for (var i in arguments) {
                    functionArgs.push(arguments[i]);
                }

                // Remove first argument (the $scope)
                functionArgs.shift();

                BaseForm.apply(form, [name, scope]);

                if (forms[formName].base) {
                    for (var i in forms[formName].base) {
                        forms[forms[formName].base[i]].form.apply(form, functionArgs);
                    }
                }

                forms[formName].form.apply(form, functionArgs);
            }
        };

        self.getFormProto = function (formName) {
            var newFormObj = function (name, scope) {
                var form = this;


                var functionArgs = [];

                for (var i in arguments) {
                    functionArgs.push(arguments[i]);
                }

                BaseForm.apply(form, [name, scope]);
                if (forms[formName].base) {
                    for (var i in forms[formName].base) {
                        forms[forms[formName].base[i]].form.apply(form, functionArgs);
                    }
                }

                forms[formName].form.apply(form, functionArgs);
            };

            newFormObj.prototype = Object.create(forms[formName].form.prototype);
            newFormObj.prototype.constructor = newFormObj;

            return newFormObj;
        };

        self.getFormInstance = function (formName) {
            var functionArgs = [];
            for (var i in arguments) {
                functionArgs.push(arguments[i]);
            }
            // Remove formName
            functionArgs.shift();
            var baseFormObj = self.getFormProto(formName);

            var newInstance = Object.create(baseFormObj.prototype)
            var result = baseFormObj.apply(newInstance, functionArgs);

            return result && typeof result === 'object' ? result : newInstance;
        };
    };

})();